export default __webpack_public_path__ + "static/media/dugar_quincy.6f04549b.jpeg";